// extracted by mini-css-extract-plugin
export default {"root":"UserCard_root__aOxRR","adminBadge":"UserCard_adminBadge__E2V64","actionsContainer":"UserCard_actionsContainer__ow7Ep","rolesContainer":"UserCard_rolesContainer__N57hV"};